import DispatchConstants from '@common/constants/DispatchConstants';
import StringConstants from '@common/constants/StringConstants';
import { getServices } from '@common/utils/serviceUtils';
import browserUtils from '@common/utils/browserUtils';
import { InitStateInterface } from '../types';

const defaultBrand = StringConstants.BRANDS.UNFORMATTED.default;

const initState = (): InitStateInterface => ({
  brand: defaultBrand,
  hostname: StringConstants.LINKS.HOME_PAGE[defaultBrand],
  baseUrl: '/',
  cookieEnabledServices: getServices(),
  isMobile: false,
  screenSize: 'xl',
  userAgent: '',
  ip: '',
  prevPage: '',
  hostApp: '',
  fromApp: '',
  isInWebView: false,
  clusterSettings: {},
});

const app = (state: InitStateInterface = initState(), action: any = {}): InitStateInterface => {
  const { type, payload } = action;

  switch (type) {
    case DispatchConstants.UPDATE_APP:
      return { ...state, ...payload };

    case DispatchConstants.SCREEN_DIMENSION_CHANGE: {
      const screenSize = browserUtils.screen.size(payload.screenWidth);
      if (state.screenSize === screenSize) {
        return state;
      }

      return {
        ...state,
        screenSize,
      };
    }

    default:
      return state;
  }
};

export default app;
